import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/withdrawRecord/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/withdrawRecord/exportExcel', data, {
    trim: true,
    download: true
  })
}

export function updateById (data) {
  return request.post('/business/withdrawRecord/updateById', data)
}
export function detail (id) {
  return request.get('/business/withdrawRecord/'+id)
}
